import { AppLayoutBreakpoint } from '../../../util/responsiveness';

import { useAppLayoutContext, useAppLayoutWidth } from './useAppLayoutContext';

/**
 * Returns whether the leftnav should be forced to its collapsed icon-only rail based on
 * the current app layout width.
 *
 * When the collapsible nav is active, the nav is forced collapsed (regardless of the
 * user's collapse preference) within the [Width632, Width828) range, so a usable nav
 * remains visible at narrower widths without crowding out the main content.
 */
export const useIsLeftNavForcedCollapsedAtCurrentWidth = (): boolean => {
  const isLeftNavCollapsible = useAppLayoutContext()?.isLeftNavCollapsible ?? false;
  const width = useAppLayoutWidth();

  return isLeftNavCollapsible && width >= AppLayoutBreakpoint.Width632 && width < AppLayoutBreakpoint.Width828;
};
